import { Mapping } from 'api/MappingsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { downloadAsCsvFile } from 'utils/csv';
import { DateFormat, TimeFormat, localizeDateTime } from 'utils/l10n';

export const useExportFields = () => {
  const dispatch = useDispatch();

  const exportFields = useCallback((fields: Mapping[], fileName: string = 'Fields') => {
    try {
      const headerRow = [
        'Field Name',
        'Description',
        'Sample value',
        'System field',
        'Visibility',
        'Type',
        'Created At',
      ];
      const tableRows = fields.map((field) => {
        const { description = '', sampleValue = '' } = field;
        const localizedDate = localizeDateTime(new Date(field.createdAt), {
          dateStyle: DateFormat.Numeric,
          showTime: true,
          timeStyle: TimeFormat.Locale,
        });

        return [
          `${field.fieldName}`,
          `${description}`,
          `${sampleValue}`,
          `${field.isSystemField ? 'TRUE' : 'FALSE'}`,
          `${field.isHidden ? 'Hidden' : 'Visible'}`,
          `${field.fieldType}`,
          `${localizedDate.replace(' at', '')}`,
        ];
      });

      downloadAsCsvFile({ rows: [headerRow, ...tableRows], fileName });
      dispatch(
        addPositiveToast('Field summary successfully exported. Please check your downloads.'),
      );
    } catch (error) {
      dispatch(
        addNegativeToastWithErrorId(
          'Field summary could not be exported. Please try again.',
          'useExportFields',
          error,
        ),
      );
    }
  }, []);

  return { exportFields };
};
